import { Box } from '@mui/material';
import { useContext } from 'react';
import { IS_SA } from '../../../../../config/appConfig';
import { InvestorStepperContext } from '../../../../../context/investorStepperContext';
import { InvestorDocumentVerificationGlobal } from './global';
import { InvestorDocumentVerificationKSA } from './ksa';

export const InvestorDocumentVerification = () => {
    const { isKsaInternationalInvestor } = useContext(InvestorStepperContext);
    const useKsaInvestorFlow = IS_SA && !isKsaInternationalInvestor;
    return (
        <Box>
            {useKsaInvestorFlow ? (
                <InvestorDocumentVerificationKSA />
            ) : (
                <InvestorDocumentVerificationGlobal />
            )}
        </Box>
    );
};
